import React from 'react';
import './FeaturesModal.css';
import { FaCheck } from 'react-icons/fa';

const FeaturesModal = ({ isOpen, onClose, allFeatures }) => {
  if (!isOpen) return null;
  return (
    <div className="features-modal-overlay" onClick={onClose}>
      <div className="features-modal-content" onClick={e => e.stopPropagation()}>
        <button className="close-modal-btn" onClick={onClose}>&times;</button>
        <h2>All Features</h2>
        <ul className="features-modal-list">
          {(allFeatures || []).map((feature, idx) => (
            <li key={idx} className="feature-with-tooltip">
              <span className="feature-check"><FaCheck /></span>
              <span className="feature-name">{feature.name}</span>
              <span className="feature-tooltip">{feature.description}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default FeaturesModal; 